module.exports = __webpack_public_path__ + "static/media/covid.67555ac9.png";